import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { reducer } from './get-all-deal-stats.reducers';
import { GetAllDealStatsEffects } from './get-all-deal-stats.effects';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([ GetAllDealStatsEffects ]),
    StoreModule.forFeature('getAllDealStats', reducer),
  ]
})
export class GetAllDealStatsModule {
}
